import LicenseBuilderSortable from "../licenseBuilderSortable";
import License from "../license";
import { LicenseStepType } from "../../enums/licenseStepType";
import PublicProfile from "../../../../common/models/publicProfile/publicProfile";

export default abstract class LicenseStep extends LicenseBuilderSortable {
  type: number;
  description: string;

  constructor(license: License | PublicProfile) {
    super();
    this.license = license;
    this.defineProperty("type", LicenseStepType.document);
  }
}
